import $ from 'jquery';
import Slider, {
  attachPaginationEvents,
  cssClassLazyloadOnSlide,
  cssClassSwiperDuplicate,
  lazyLoadImage,
} from '../../js/modules/Slider.mjs';
import {CSS_CLASS_ANIMATED_LINE} from '../../js/Ui.mjs';

const $sliders = $('.js_ef-collection-teaser-image');

$sliders.each((index, slider) => {
  const $slider = $(slider);
  const SliderCollectionTeaserImage = new Slider({
    namespace: 'CollectionTeaseImage',
    sliderNode: slider,
    swiperConfigOverride: {
      autoHeight: true,
      on : {
        init() {
          // Workaround line animation, when Swiper duplicates slides
          $slider.find(`.${cssClassSwiperDuplicate} ${CSS_CLASS_ANIMATED_LINE}`).addClass('-animate');
        },
        lazyImageLoad: lazyLoadImage,
        paginationRender(swiper) {
          attachPaginationEvents(swiper);
        },
      },
    },
  });

  if (SliderCollectionTeaserImage.slidesDontFitIntoWrapper()) {
    SliderCollectionTeaserImage.init();
  } else {
    $slider.find(`.${cssClassLazyloadOnSlide}`).addClass('lazyload');
  }
  SliderCollectionTeaserImage.attachResize();
});
